import * as yup from "yup";

export type FormValues = {
  phoneNumber: string;
};

export const validationSchema = yup.object({
  phoneNumber: yup
    .string()
    .transform((value) => value.replace(/[^\d]/g, ""))
    .length(12, "Неправильний формат номера телефону")
    .required("Вкажіть телефон"),
});
